<script lang="ts" setup>
import { useBodyStore } from '@autobid/nuxt-pinia-store/store/useBodyStore'
import { storeToRefs } from 'pinia'
import { onMounted, ref, watch } from 'vue'

const wrapper = ref<HTMLElement>()

const scrollWidth = ref<number>(0)
const { resolution } = storeToRefs(useBodyStore())
const resizeDebounce = ref<NodeJS.Timeout>()

function handleScroll() {
  if (!wrapper.value?.previousElementSibling) {
    return
  }

  wrapper.value.previousElementSibling.scrollLeft = wrapper.value.scrollLeft
}

function handleTopScroll(e: Event) {
  if (!wrapper.value) {
    return
  }

  const target = e.target as HTMLElement
  wrapper.value.scrollLeft = target.scrollLeft
}

function setTopScrollWidth() {
  if (!wrapper.value)
    return

  scrollWidth.value = wrapper.value.scrollWidth
}

onMounted(() => {
  setTopScrollWidth()
})

watch([resolution, wrapper], () => {
  clearTimeout(resizeDebounce.value)

  resizeDebounce.value = setTimeout(() => {
    setTopScrollWidth()
  }, 500)
})
</script>

<template>
  <div>
    <div class="overflow-x-auto lg:hidden" @scroll="handleTopScroll">
      <div class="h-1" :style="{ width: `${scrollWidth}px` }" />
    </div>

    <div
      ref="wrapper"
      class="overflow-x-auto lg:overflow-x-visible"
      @scroll="handleScroll"
    >
      <slot />
    </div>
  </div>
</template>
